// Loading Spinner Component (per brain pattern)
import { Box, CircularProgress, Typography } from '@mui/material';

type LoadingSpinnerProps = {
  message?: string;
  fullPage?: boolean;
};

export const LoadingSpinner = ({ message, fullPage = false }: LoadingSpinnerProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      ...(fullPage && { minHeight: '100vh' }),
      py: 4,
    }}
  >
    <CircularProgress />
    {message && (
      <Typography color="text.secondary">{message}</Typography>
    )}
  </Box>
);
